import React from 'react'
import clsx from 'clsx'
import { useTranslation } from 'react-i18next'
import { Box, Card, Input, LineChart } from '@node-space/ui-components'
import { useRewardsSheetContext } from '../context/RewardsSheetProvider'
import { useCalculateRewards } from '../hooks/useCalculateRewards'
import { useChartProps } from '../hooks/useChartProps'
import { useRewardsForm } from '../hooks/useRewardsForm'
import { RewardsCryptoSelect } from './RewardsCryptoSelect'

export const RewardCompoundedCalculator = () => {
  const { t } = useTranslation()
  const { rewardsProducts } = useRewardsSheetContext()
  const { amount, selectedCurrency, formattedAmount, onAmountChange, onCurrencyChange } =
    useRewardsForm()
  const apyRate =
    rewardsProducts?.find(product => product.currency === selectedCurrency)?.earningRate || 0
  const { rewardsData } = useCalculateRewards(amount, apyRate)
  const chartProps = useChartProps(rewardsData)

  const showCryptoSelect = rewardsProducts.length > 1

  return (
    <Card variant="static" full>
      <Box flexCol gapY={24}>
        <h2 className="text-h4 text-foreground-prominent">
          {t('rewards.expectedRewardsDescription')}
        </h2>

        <Box
          className={clsx('grid grid-cols-1  gap-4', {
            'grid-cols-[255px_255px_auto]': showCryptoSelect,
            'max-w-[526px]': !showCryptoSelect,
          })}
        >
          {showCryptoSelect && (
            <RewardsCryptoSelect
              rewardsProducts={rewardsProducts}
              currency={selectedCurrency}
              onChange={onCurrencyChange}
            />
          )}

          <Input
            label={t('rewards.allocateAmount')}
            placeholder={t('rewards.allocateAmountPlaceholder')}
            inputMode="numeric"
            value={formattedAmount}
            onChange={onAmountChange}
            rightSuffixText={selectedCurrency}
          />
        </Box>

        <Box className="mt-2">
          <LineChart {...chartProps} />
        </Box>
      </Box>
    </Card>
  )
}
